import type { CuratedList } from '~~/core/entities/CuratedList';
import type { ResultTuple } from '~~/core/helpers/result';

import { Result } from '~~/core/helpers/result';
import { createOriginalErrorObject } from '~~/server/utils/errorHandling';

interface CollectionService {
	getOne(params: { slug: string }): Promise<ResultTuple<CuratedList | null>>;
	getMany(): Promise<ResultTuple<CuratedList[]>>;
}

export const nuxtCollectionService: CollectionService = {
	async getOne({ slug }) {
		try {
			const response = await $fetch<CuratedList | null>(
				`/api/curated_list/${slug}`,
				{
					method: 'GET'
				}
			);

			return Result.ok(response || null);
		} catch (error) {
			return Result.error({
				message: `Error while getting the collection.`,
				source: 'nuxtCollectionService.getOne',
				originalErrorObject: createOriginalErrorObject(error)
			});
		}
	},
	async getMany() {
		try {
			const response = await $fetch<CuratedList[]>('/api/curated_list', {
				method: 'GET'
			});

			return Result.ok(response || []);
		} catch (error) {
			return Result.error({
				message: `Error while fetching collections.`,
				source: 'nuxtCollectionService.getMany',
				originalErrorObject: createOriginalErrorObject(error)
			});
		}
	}
};
